<div class="document-wrapper">
  <!-- <div style="flex-grow: 1;display: flex;flex-direction:column;"> -->
  <div style="width: 100%;" class="dynamicStepper">
    <mat-horizontal-stepper [linear]="isLinear" #stepper class="custom-stepper" [selectedIndex]="selectedStep"
      (selectionChange)="onStepClick($event)">

      <ng-template matStepperIcon="number" let-index="index">
        <mat-icon *ngIf="stepper.selectedIndex === index">{{ getStepIcon(index) }}</mat-icon>
        <mat-icon *ngIf="stepStatus[index] === 'normal' && stepper.selectedIndex !== index">{{
          getStepIcon(index)}}</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        <mat-icon color="primary">{{ getStepIcon(index) }}</mat-icon>
      </ng-template>
      <mat-step class="dynamicStepper" *ngFor="let step of stepItems; let i = index;" [label]="step"
        [completed]="isCompleted(i)"></mat-step>
    </mat-horizontal-stepper>

  </div>

  <hr class="section-divider">

  <div>
    <div *ngIf="selectedStep == 0">
      <select-project-tab [projectForm]="projectForm" [isCopyMode]="isCopyMode"></select-project-tab>
    </div>
  <div *ngIf="selectedStep == 1">
    <app-select-collection (isButtonEnabled)="handleButtonState($event)" [collectionId]="collectionId"
      [subCollectionIds]="subCollectionIds"></app-select-collection>
  </div>
  <div *ngIf="selectedStep == 2">
    <app-select-department (selectedDepartmentsChange)="onSelectedDepartmentsChange($event)" (selectedMembersChange)="onSelectedMembersChange($event)"
    [preSelectedDepartmentIds]="selectedDeptData" [preSelectedMemberIds]="selectedMemberData" [preSelectedDepartments]="preSelectedDepartments">
    </app-select-department>
  </div>

  <div *ngIf="selectedStep == 3">
    <app-select-email [emailForm]="emailForm"></app-select-email>
  </div>

  <div *ngIf="selectedStep == 4">
    <app-select-attachments (selectedCountChange)="onAttachmentsSelectedCount($event)"></app-select-attachments>
  </div>

  <div *ngIf="selectedStep == 5">
    <app-summary (navigateToProject)="goToStep(0)" (navigateToCollection)="goToStep(1)" (navigateToTeam)="goToStep(2)"
      (navigateToEmail)="goToStep(3)" (navigateToDocuments)="goToStep(4)">
    </app-summary>
  </div>
  </div><!-- /tour-mds-step-content -->

  <div class="divider2"></div>
  <div class="actions" style="bottom: 0;position: sticky;z-index: 998;border-top: 1px solid #ddd;gap: 10px;">
    <div class="left-buttons">
      <button class="btn1 btn-save disabled" *ngIf="selectedStep >1" [disabled]="isSaveDraftDisabled"
         (click)="openSaveDraftDialog()">Save Draft</button>
      <!-- <button class="btn2 btn-cancel" (click)="onCancel()">Cancel</button> -->
    </div>

    <div class="right-buttons">
      <!-- Previous Button - Always visible -->
      <button class="btn btn-prev" [disabled]="selectedStep === 0" (click)="onPrevious()">
        <mat-icon style="font-size: 25px;">chevron_left</mat-icon> Previous
      </button>

      <!-- Next Button - Show on all steps except last -->
      <button *ngIf="selectedStep < stepItems.length-1" class="btn btn-next" (click)="onNext()"
        [disabled]="!isNextEnable()"
        matTooltip="{{ isButtonDisabled ? '' : 'All fields are entered! Please proceed to the next screen!' }}"
        matTooltipPosition="above">
        Next Step: {{ stepItems[selectedStep + 1] }}
      </button>

      <!-- Submit Button - Show only on last step -->
      <button *ngIf="selectedStep === stepItems.length-1" class="btn btn-next" (click)="onSubmit()">
        Submit
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Dialog Template -->
<ng-template #submitDialog>
  <div style="padding: 24px;">
    <h2 style="margin: 0 0 16px 0; font-size: 20px; font-weight: 600; color: #111827;">
      Confirm Submission
    </h2>
    <p style="margin: 0 0 24px 0; font-size: 14px; color: #6b7280;">
      Are you sure you want to submit all details?
    </p>
    <div style="display: flex; justify-content: flex-end; gap: 12px;margin-top: 20px;">
      <button mat-button [mat-dialog-close]="false"
        style="padding: 8px 16px; border: 1px solid #d1d5db; border-radius: 8px; background: white; color: #374151; font-weight: 500; cursor: pointer;">
        No
      </button>
      <button mat-button [mat-dialog-close]="true"
        style="padding: 8px 16px; border: none; border-radius: 8px; background: #cc0000; color: white; font-weight: 500; cursor: pointer;">
        Yes
      </button>
    </div>
  </div>
</ng-template>

<ng-template #successDialog>
  <div class="modal-content border-0 background-color success-modal">
    <div class="modal-body p-4 text-center">
      <!-- Success Icon -->
      <div class="mb-3 success-icon-container">
        <div class="d-inline-flex align-items-center justify-content-center rounded-circle success-circle">
          <mat-icon class="red" style="font-size: 48px; width: 48px; height: 48px;">check_circle_outline</mat-icon>
        </div>
      </div>

      <!-- Title -->
      <label class="fw-semibold text-dark mb-3 s-msg">
        Submission Successful!
      </label>

      <!-- Description -->
      <p class="text-clr mb-2 font">
        Your project has been submitted successfully.
      </p>

      <!-- Project Details Card -->
      <div class="rounded p-3 mb-2 text-start">
        <div class="mb-2 p-2 rounded-3 bg-3">
          <small class="text-clr d-block mb-1">Project Name</small>
          <p class="font-3">{{ createProjectService.getSelectedProject()?.projectName }}</p>
        </div>
        <div class="mb-2 p-2 rounded-3 bg-3">
          <small class="text-clr d-block mb-1">Submitted on</small>
          <p class="font-3">{{ Date.now() | date:'MMMM d, y \'at\' h:mm a' }}
          </p>
        </div>
      </div>

      <!-- Action Button -->
      <button [mat-dialog-close]="true" class="view w-100">
        View Dashboard
      </button>

      <!-- Footer Note -->
      <p class="text-clr font-2 mt-3 mb-0">
        A confirmation email has been sent to your registered email address.
      </p>
    </div>
  </div>
</ng-template>